import algoliasearch from 'algoliasearch/lite';
import config from '../../../config';
import { mergeHitsWithPrices } from './productFilterHelpers';

// The whole buy catalog, in the one request the Target Price product-selection
// screen makes for it (an empty query, up to 200 hits).
const CATALOG_PAGE_SIZE = 200;

let buyIndex;
// Created on first use, once, rather than when the module loads.
const getBuyIndex = () => {
  if (!buyIndex) {
    const { apiKey, apiSecret, apiBuyIndex } = config.algoliaSearch;
    buyIndex = algoliasearch(apiKey, apiSecret).initIndex(apiBuyIndex);
  }

  return buyIndex;
};

// A buy-catalog product by its code, wherever it sits in the index: the Algolia
// hit merged with its price record, as the Buy page and the product-selection
// screen list it. The Buy page's own list is only Algolia's first page, less
// whatever its filters remove, so it can't be relied on to hold the product.
// Resolves to undefined for a code that has no hit or no price record (it can't
// be ordered, like on the Buy page), and rejects when the request fails.
export const findBuyCatalogProduct = (productCode, productPrices) =>
  getBuyIndex()
    .search('', { hitsPerPage: CATALOG_PAGE_SIZE })
    .then(({ hits }) =>
      mergeHitsWithPrices(hits, productPrices).find(
        (product) => (product.ProductCode || product.Code) === productCode,
      ),
    );

export default findBuyCatalogProduct;
